import { Box, Typography, useTheme } from "@mui/material";
import DataGridCustom from "components/DataGridCustom";
import DataGridCustomToolbar from "components/DataGridCustomToolbar";
import Header from "components/Header";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useGetInventoryQuery } from "state/api";
import AddInventory from "../AddInventory/";
import Cards from "./cards";
import { getGridSingleSelectOperators } from "@mui/x-data-grid";
import { localFileUrl } from "../../../utils";
const { useSelector } = require("react-redux");

const Cars = () => {
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [sort, setSort] = useState({ field: "createdAt", sort: "desc" });
  const [search, setSearch] = useState("");
  const [searchInput, setSearchInput] = useState("");
  const [filter, setFilter] = useState({});

  const theme = useTheme();
  const { data, isLoading } = useGetInventoryQuery({
    page,
    pageSize,
    sort: JSON.stringify(sort),
    search,
    filter: JSON.stringify(filter),
  }); // Fetching data from the API
  const userRole = useSelector((state) => state.auth.userInfo.role);
  const columns = [
    {
      field: "media",
      headerName: "Thumbnail",
      flex: 0.9,
      filterable: false,
      renderCell: (params) => {
        return (
          <img
            src={localFileUrl(params.value.thumbnail.url)}
            alt="thumbnail"
            width="100%"
            style={{ objectFit: "contain", borderRadius: "0.5rem" }}
          />
        );
      },
    },

    {
      field: "_id",
      headerName: "ID",
      filterable: false,
      renderCell: (params) => (
        <Link
          to={{
            pathname: `/inventory-view`,
            search: `?id=${params.row._id}`,
          }}
          // target="_blank"
        >
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.secondary[200],
              textDecoration: "none",
              "&:hover": {
                textDecoration: "underline",
              },
            }}
          >
            {params.value}
          </Typography>
        </Link>
      ),
      flex: 0.4,
      hide: true,
    },
    {
      // use name as hyperlink to the car details page
      field: "name",
      headerName: "Name",
      flex: 0.5,
      filterable: false,
      renderCell: (params) => (
        <Link
          to={{
            pathname: `/inventory-view`,
            search: `?id=${params.row._id}`,
          }}
          // target="_blank"
        >
          <Typography
            variant="body2"
            sx={{
              color: theme.palette.secondary[200],
              textDecoration: "underline",
              "&:hover": {
                color: "#1976d2",
                textDecoration: "underline",
              },
            }}
          >
            {params.value}
          </Typography>
        </Link>
      ),
    },
    {
      field: "model",
      headerName: "Model",
      flex: 0.5,
      filterable: false,
    },
    {
      field: "variant",
      headerName: "Variant",
      flex: 0.5,
      filterable: false,
    },
    {
      field: "yearOfManufacture",
      headerName: "Year of Manufacture",
      flex: 0.5,
    },
    {
      field: "color",
      headerName: "Color",
      flex: 0.5,
      hide: true,
      filterable: false,
    },
    {
      field: "engineNumber",
      headerName: "Engine Number",
      flex: 0.5,
      hide: true,
      filterable: false,
    },
    {
      field: "registrationType",
      headerName: "Registration Type",
      flex: 1,
      hide: true,
      filterable: false,
    },
    {
      field: "ownerSerial",
      headerName: "Owner Serial",
      flex: 0.5,
      hide: true,
      filterable: false,
    },
    {
      field: "transmission",
      headerName: "Transmission",
      flex: 0.5,
      hide: true,
      filterable: false,
    },
    {
      field: "fuelType",
      headerName: "Fuel Type",
      flex: 0.5,
      hide: true,
      type: "singleSelect",
      valueOptions: [
        "Petrol",
        "Diesel",
        "CNG",
        "LPG",
        "Electric",
        "Hybrid",
        "Other",
      ],
      filterOperators: getGridSingleSelectOperators().filter(
        // remove is not and is any of
        (operator) => {
          return operator.value !== "not" && operator.value !== "isAnyOf";
        }
      ),
    },
    {
      field: "registrationExpiryDate",
      headerName: "Registration Expiry Date",
      flex: 0.5,
      renderCell: (params) => (
        <Typography>{new Date(params.value).toLocaleDateString()}</Typography>
      ),
      hide: true,
    },
    {
      field: "registrationDate",
      headerName: "Registration Date",
      flex: 0.5,
      renderCell: (params) => (
        <Typography>{new Date(params.value).toLocaleDateString()}</Typography>
      ),
      hide: true,
    },
    {
      field: "insuranceExpiryDate",
      headerName: "Insurance Expiry Date",
      flex: 0.5,
      renderCell: (params) => (
        <Typography>{new Date(params.value).toLocaleDateString()}</Typography>
      ),
      hide: true,
    },
    {
      field: "price",
      headerName: "Price",
      flex: 0.5,
      renderCell: (params) => (
        <Typography>
          {params.value.toLocaleString("en-IN", {
            style: "currency",
            currency: "INR",
          })}
        </Typography>
      ),
    },
    {
      field: "kmsDriven",
      headerName: "Kms Driven",
      flex: 0.5,
      renderCell: (params) => (
        <Typography>
          {params.value.toLocaleString("en-IN", {
            style: "decimal",
          })}
        </Typography>
      ),
      hide: true,
    },
    {
      field: "status",
      headerName: "Status",
      flex: 0.6,

      type: "singleSelect",
      valueOptions: [
        "Available",
        "Sold",
        "Booked",
        "Pending Approval",
        "Archived",
      ],

      // disable is any of filter
      filterOperators: getGridSingleSelectOperators().filter(
        // remove is not and is any of
        (operator) => {
          return operator.value !== "not" && operator.value !== "isAnyOf";
        }
      ),
    },
    {
      field: "inventoryType",
      headerName: "Inventory Type",
      flex: 0.5,
      hide: true,
      type: "singleSelect",
      valueOptions: ["Invested", "Parked", "Dealer's Stock"],
      filterOperators: getGridSingleSelectOperators().filter(
        // remove is not and is any of
        (operator) => {
          return operator.value !== "not" && operator.value !== "isAnyOf";
        }
      ),
    },

    {
      field: "vehicleNumber",
      headerName: "Vehicle Number",
      flex: 0.5,
      hide: true,
      filterable: false,
    },
  ];

  return (
    <Box m="1.5rem 2.5rem">
      <Header title="CARS" subtitle="List of Cars" button={<AddInventory />} />
      <Cards />
      <Box mt="40px" height="75vh">
        <DataGridCustom
          loading={isLoading || !data}
          getRowId={(row) => row._id}
          rows={(data && data.result) || []}
          columns={columns}
          rowCount={(data && data.total) || 0}
          rowsPerPageOptions={[10, 20, 50]}
          pagination
          pageSize={pageSize}
          paginationMode="server"
          sortingMode="server"
          onPageChange={(newPage) => setPage(newPage)}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          onSortModelChange={(newSortModel) => {
            setSort(...newSortModel);
          }}
          filterMode="server"
          onFilterModelChange={(model) => {
            // setSearch(model.items[0]?.value || "");
            setFilter(model.items[0] || {});
          }}
          components={{ Toolbar: DataGridCustomToolbar }}
          componentsProps={{
            toolbar: {
              searchInput,
              setSearchInput,
              setSearch,
              userRole,
            },
          }}
          // onRowDoubleClick={(params) => {
          //   window.location.href = `/inventory/${params.row._id}`;
          // }}
          rowHeight={250}
          autoHeight
        />
      </Box>
    </Box>
  );
};

export default Cars;
